export default "__VITE_ASSET__a0baa28e__"